import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';

import './GroupsField.css';

const GroupsField = ({ name, groups, onChange, fixedWidth, single, className }) => {
    const { t } = useTranslation();

    if (!groups)
        return null;

    groups = groups.sort((a, b) => a.min_age === b.min_age ? a.name.localeCompare(b.name) : a.min_age - b.min_age);

    const options = groups.map(group => ({
        key: group.id,
        text: group.name + ' (' + group.getAgesText() + ')',
        value: group.id
    }));

    const onFieldChange = (value) => {
        return onChange ? onChange(value) : true;
    }

    return single ? (
        <SelectField
            name={ name }
            options={ options }
            placeholder={ t('groups.choose_a_group') }
            onSelectChange={ onFieldChange }
            fixedWidth={ fixedWidth }
            clearable
            className={ className }
        />
    ) : (
        <MultiSelectField
            name={ name }
            options={ options }
            placeholder={ t('groups.choose_some_groups') }
            onSelectChange={ onFieldChange }
            fixedWidth={ fixedWidth }
            className={ className }
        />
    );
}

export default GroupsField;
